import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Hero from "./components/Hero/Hero.js";
import RegisterPage from "./components/RegisterPage/RegisterPage.js";
import Offers from "./components/JobOffers/Offers.js";
import Navbar from "./components/Navbar/Navbar.js";

import { initPixel } from "./pixel.js";
import MetaPixelRouteTracking from "./MetaPixelRouteTracking.js";

const App = () => {
  useEffect(() => {
    initPixel();
  }, []);

  return (
    <Router>
      {/* Tracks PageView on every route change */}
      <MetaPixelRouteTracking />

      <main className="overflow-x-hidden bg-white text-dark">
        <Navbar />
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/emplois" element={<Offers />} />
        </Routes>
      </main>
    </Router>
  );
};

export default App;
